export const drawVehicleManufacturerLabel = (vehicleManufacturer) => {
    return vehicleManufacturer.name;
};
